import React from "react";
import Icon from "@ant-design/icons";
import { Dropdown, Menu } from "antd";

import { ReactComponent as DownArrow } from "@assets/images/svg/white-down-arrow.svg";
import { ReactComponent as UserIcon } from "@assets/images/svg/user.svg";

import Auth from "config/auth";

const onClick = () => {};

const logoutUser = () => {
  Auth.removeSessionKey();
  window.location.replace("/login");
  localStorage.removeItem("role");
  localStorage.removeItem("loggedInUser");
  localStorage.removeItem("eUserRoles");
  localStorage.removeItem("clientSettings");
  sessionStorage.removeItem("uniqueTabRole");
  sessionStorage.removeItem("role");
};

const menu = () => (
  <Menu onClick={onClick}>
    <Menu.Item key="3" onClick={logoutUser}>
      Log out
    </Menu.Item>
  </Menu>
);

const HeaderMenu = () => {
  const { userName = "" } = Auth.getSessionDetails();
  return (
    <Dropdown overlay={menu()}>
      <a className="ant-dropdown-link user-menu" onClick={event => event.preventDefault()}>
        <Icon component={UserIcon} />
        <span className="user-name-profile">{userName}</span>
        <Icon component={DownArrow} />
      </a>
    </Dropdown>

  );
};

export default React.memo(HeaderMenu);